import { GET_ALL_PRODUCT, GET_LIST_ATTRIBUTE, GET_LIST_CALCULATION_FORMULA, GET_LIST_CATEGORY, GET_LIST_COM, GET_PRODUCT_DETAIL,GET_LIST_UNIT } from "./type";

export const initialState = {
  listAttribute: [],
  listCategory: [],
  listUnit: [],
  allProduct: [],
  listCalFormula: [],
  listCom: [],
  productDetail: null,
};

export function prdManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_ATTRIBUTE:
      return {
        ...state,
        listAttribute: action.payload.data
      };
    case GET_LIST_CATEGORY:
      return {
        ...state,
        listCategory: action.payload.data
      };
    case GET_ALL_PRODUCT:

      return {
        ...state,
        allProduct: action.payload.data.filter(item => item.Product.Status == 1)
        //status==1 còn hàng
        //status==2 hết hàng
      };
    case GET_LIST_CALCULATION_FORMULA:
      return {
        ...state,
        listCalFormula: action.payload.data
      };
    case GET_LIST_UNIT:
      return {
        ...state,
        listUnit: action.payload.data
      };
    case GET_LIST_COM:
      return {
        ...state,
        listCom: action.payload.data
      };
    case GET_PRODUCT_DETAIL:
      return {
        ...state,
        productDetail: action.payload.data
      };
    default:
      return state;
  }
}
